import { Keys } from '../types';

const keys: Keys = {
  infura: 'daaa68ec242643719749dd1caba2fc66',
};

export default keys;
